import { useEffect, useState } from "react";
import { Download, X, Smartphone, Apple } from "lucide-react";

const STORAGE_KEY = "runspot_pwa_dismissed";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [showAndroid, setShowAndroid] = useState(false);
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;

    // Already installed
    if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShowAndroid(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    // iOS detection (no beforeinstallprompt support)
    const ua = window.navigator.userAgent;
    const isIOS = /iphone|ipad|ipod/i.test(ua) && !/CriOS|FxiOS/i.test(ua);
    if (isIOS) {
      setTimeout(() => setShowIOS(true), 4000);
    }

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") {
      localStorage.setItem(STORAGE_KEY, "1");
    }
    setDeferred(null);
    setShowAndroid(false);
  };

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setShowAndroid(false);
    setShowIOS(false);
  };

  if (!showAndroid && !showIOS) return null;

  return (
    <div data-testid="install-prompt"
      className="fixed bottom-4 left-3 right-3 sm:left-auto sm:right-6 sm:bottom-6 z-[2000] sm:max-w-sm">
      <div className="bg-white rounded-3xl shadow-2xl shadow-black/25 border border-black/5 p-4 flex items-start gap-3">
        <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#FF6B35] to-[#E84A1F] flex items-center justify-center text-white shadow-md shadow-[#FF6B35]/30 shrink-0">
          {showIOS ? <Apple size={22} /> : <Smartphone size={20} />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-[#1A1A1A] text-base">
            Installer RunSpot
          </div>
          {showIOS ? (
            <p className="text-xs text-[#1A1A1A]/70 mt-1 leading-relaxed">
              Appuie sur <span className="inline-block">⎙</span> Partager puis <strong>« Sur l'écran d'accueil »</strong> pour ajouter RunSpot comme une vraie app.
            </p>
          ) : (
            <p className="text-xs text-[#1A1A1A]/70 mt-1">
              Ajoute RunSpot sur ton écran d'accueil et accède aux spots péi en 1 clic.
            </p>
          )}
          {showAndroid && (
            <button data-testid="install-btn" onClick={install}
              className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#FF6B35] to-[#E84A1F] hover:opacity-90 text-white text-xs font-bold py-2 px-4 shadow-md shadow-[#FF6B35]/30">
              <Download size={13}/> Installer
            </button>
          )}
        </div>
        <button onClick={dismiss} data-testid="install-dismiss"
          className="shrink-0 w-7 h-7 rounded-full hover:bg-[#FAF1E1] flex items-center justify-center text-[#1A1A1A]/50">
          <X size={15}/>
        </button>
      </div>
    </div>
  );
}
